module.exports = __webpack_public_path__ + "img/fi-rr-cursor-finger.033ce794.svg";